import { h, Host } from "@stencil/core";
export class GxgTooltip {
    constructor() {
        this.position = "top";
        this.label = undefined;
        this.alignEnd = false;
        this.fixed = false;
        this.flex = false;
        this.noBorder = false;
        this.visible = false;
    }
    el;
    tooltipTextEl;
    componentWillLoad() {
        if (this.fixed) {
            this.el.addEventListener("mouseenter", this.mouseEnterHandler);
            this.el.addEventListener("mouseleave", this.mouseLeaveHandler);
            document.addEventListener("scroll", this.documentScrollHandler);
        }
    }
    mouseEnterHandler = () => {
        const tooltipBC = this.el.getBoundingClientRect();
        const top = tooltipBC.top;
        const leftPosition = tooltipBC.left;
        const width = tooltipBC.width;
        this.tooltipTextEl.style.top = `${top}px`;
        this.tooltipTextEl.style.left = `${leftPosition + width}px`;
        this.visible = true;
    };
    mouseLeaveHandler = () => {
        this.visible = false;
    };
    documentScrollHandler = () => {
        this.visible = false;
    };
    render() {
        return (h(Host, { role: "tooltip" }, h("span", { class: { tooltip: true, "tooltip--visible": this.visible } }, h("slot", null), h("div", { class: "tooltiptext", ref: (el) => (this.tooltipTextEl = el) }, h("span", { class: "tooltiptext__content" }, this.label)))));
    }
    static get is() { return "gxg-tooltip"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tooltip.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tooltip.css"]
        };
    }
    static get properties() {
        return {
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "position",
                    "resolved": "\"bottom\" | \"left\" | \"right\" | \"top\"",
                    "references": {
                        "position": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tooltip/tooltip.tsx",
                            "id": "src/components/tooltip/tooltip.tsx::position"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the tooltip position"
                },
                "attribute": "position",
                "reflect": true,
                "defaultValue": "\"top\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label"
                },
                "attribute": "label",
                "reflect": false
            },
            "alignEnd": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The alignment"
                },
                "attribute": "align-end",
                "reflect": true,
                "defaultValue": "false"
            },
            "fixed": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Fixed positioned"
                },
                "attribute": "fixed",
                "reflect": true,
                "defaultValue": "false"
            },
            "flex": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Displays the tool-tip as flex"
                },
                "attribute": "flex",
                "reflect": true,
                "defaultValue": "false"
            },
            "noBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This presence of this property removes the border under the text"
                },
                "attribute": "no-border",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "visible": {}
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=tooltip.js.map
